import TasksPage from "@/pages/tasks/TasksPage";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Tasks route definition
 */

export const Route = createFileRoute("/tasks")({
  component: TasksPage,
  validateSearch: (search: Record<string, unknown>) => ({
    highlightUid:
      typeof search.highlightUid === "string" ? search.highlightUid : undefined,
  }),
});
